import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//img
import jioPhotos from "../../assets/svg/jiophotos-logo-black.svg";
import { ActionButton, Container, Icon, Image, Text } from "@jds/core";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(10);
  useEffect(() => {
    if (seconds === 0) {
      // Redirect when timer reaches zero
      const url = localStorage.redirectUrl;
      localStorage.removeItem("redirectUrl");
      if (url) {
        window.location.href = url;
      } else {
        navigate("/home");
      }
      return;
    }

    const intervalId = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds - 1);
    }, 1000);

    // Clear the interval on component unmount
    return () => clearInterval(intervalId);
  }, [seconds, localStorage.redirectUrl]);
  return (
    <Container
      fullWidth
      verticalAlign="center"
      style={{ height: "100vh" }}
      horizontalAlign="center"
    >
      <Container direction="column" horizontalAlign="center" gap={1}>
        <Container
          style={{
            marginBottom: "20px",
          }}
        >
          <img src={jioPhotos} />
        </Container>

        <Container gap={10} verticalAlign="center">
          <Icon ic={"IcSuccessColored"} kind="background" size="xxl" />
          <Text appearance="heading-xs">Payment Successful!</Text>
        </Container>
        <Container
          fullWidth
          horizontalAlign="center"
          style={{ margin: "16px 0 20px" }}
          direction="column"
        >
          <Text appearance="body-m" color="primary_grey_80">
            Congratulations! Your storage has been successfully upgraded. You
            can now enjoy enhanced storage capabilities.
          </Text>
          <Text appearance="body-m" color="primary_grey_80">
            Thank you for your purchase!
          </Text>

          <br />
          <Text appearance="body-m" color="primary_grey_80">
            You will be redirected{" "}
            <span
              onClick={() => {
                const url = localStorage.redirectUrl;
                localStorage.removeItem("redirectUrl");
                if (url) {
                  window.location.href = url;
                } else {
                  navigate("/home");
                }
              }}
              style={{
                color: "#3535f3",
                cursor: "pointer",
              }}
            >
              back to the previous page
            </span>{" "}
            in {seconds} seconds
          </Text>
        </Container>
      </Container>
    </Container>
  );
};

export default PaymentSuccess;
